// extracted by mini-css-extract-plugin
module.exports = {"customCheckbox":"Checkbox_customCheckbox__2E2Bc"};